import { observer } from 'mobx-react';
import Main from '../../../../../BrowserSupport/Main';
import Notifications from '../../../../../Notifications';
import I18nTitle from '../../../../../Title/I18nTitle';
import Footer from '../../../../Footer';
import withRouter from '../../WithRouter';
import PreviewBuilder from './PreviewBuilder';
import { PreviewLicenseProvider } from './PreviewLicenseContext';

// DVLP-7601: admin collection preview page. Mirrors BuilderV2Edit's outer
// chrome (Notifications, Main, Footer, I18nTitle) so it looks and behaves like
// the v2 builder — the interior is read-only via `stateKind="preview"` in
// ReadyBuilder and its downstream Section/SectionsLoader chain.
interface Props {
  params: { id: string };
}

function AdminPreview({ params }: Props) {
  return (
    <>
      <I18nTitle title="Learning Collection Preview" />
      <div>
        <Notifications />
        <Main
          id="main"
          // DVLP-7601: no max-width here so the sticky blue bar spans the full
          // viewport; its inner container and the sections below center
          // themselves, so text position is unchanged.
          className="min-h-[calc(100vh-230px)] w-full"
        >
          <PreviewLicenseProvider learningCollectionId={params.id}>
            <PreviewBuilder id={params.id} />
          </PreviewLicenseProvider>
        </Main>
        <Footer className="text-left max-w-clientPortalMaxWidth w-full mx-auto pl-12 border-t text-xs" />
      </div>
    </>
  );
}

export default withRouter(observer(AdminPreview));
